import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["upload", "imageUrl", "preview", "placeholder"];

  connect() {
    this.update();
  }

  disconnect() {
    this.releaseFileUrl();
  }

  update() {
    this.releaseFileUrl();
    const file = this.uploadTarget.files?.[0];
    const url = this.imageUrlTarget.value.trim();
    const source = file ? (this.fileUrl = URL.createObjectURL(file)) : (/^https?:\/\//i.test(url) ? url : "");

    this.previewTarget.classList.toggle("hidden", !source);
    this.placeholderTarget.classList.toggle("hidden", !!source);
    if (source) this.previewTarget.src = source;
    else this.previewTarget.removeAttribute("src");
  }

  imageFailed() {
    this.previewTarget.classList.add("hidden");
    this.placeholderTarget.classList.remove("hidden");
  }

  releaseFileUrl() {
    if (this.fileUrl) URL.revokeObjectURL(this.fileUrl);
    this.fileUrl = null;
  }
}
